import { recordMatchesClientCategory, normalizeClientDetailCategory } from "./clientDetailsCategory";
import {
  getInvoicePaymentStatusLabel,
  isInvoiceCancelled,
} from "./invoiceStatusDisplay";

/** Format dashboard stat values (counts vs currency). */
export function formatDashboardCardValue(value, format) {
  if (format === "currency") {
    const num = Number(value);
    if (!Number.isFinite(num)) return "$ 0.00";
    const formatted = new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(num);
    return `$ ${formatted}`;
  }
  return value ?? 0;
}

/** Pick nested or flat dashboard card payload for a category. */
export function resolveDashboardCardDetailsForCategory(details, category) {
  if (!details || typeof details !== "object" || Array.isArray(details)) {
    return {};
  }

  const cat = normalizeClientDetailCategory(category);
  const nested = details[cat];
  if (nested && typeof nested === "object" && !Array.isArray(nested)) {
    return nested;
  }

  return details;
}

/** Client dashboard stat cards scoped to Individual / Business. */
export function buildClientDashboardCardCounts({
  apiDetails,
  category,
  invoices = [],
  documents = [],
}) {
  const cat = normalizeClientDetailCategory(category);
  const base = resolveDashboardCardDetailsForCategory(apiDetails, cat);

  const scopedInvoices = (invoices || []).filter((invoice) =>
    recordMatchesClientCategory(invoice, cat),
  );

  const paymentsCount = scopedInvoices.filter((invoice) => {
    if (!invoice || isInvoiceCancelled(invoice)) return false;
    const statusLabel = getInvoicePaymentStatusLabel(invoice);
    if (!["Pending", "Partially Paid"].includes(statusLabel)) return false;
    return Number(invoice.total || 0) > 0;
  }).length;

  const documentsCount = (documents || []).filter((doc) =>
    recordMatchesClientCategory(doc, cat),
  ).length;

  return {
    ...base,
    Documents: documentsCount,
    Invoice:
      paymentsCount ?? base.Invoice ?? base.Invoices ?? base.Payments ?? 0,
    Invoices:
      paymentsCount ?? base.Invoices ?? base.Invoice ?? base.Payments ?? 0,
    Referrals: base.Referrals ?? base["Refer a friend"] ?? 0,
  };
}
